module.exports = __webpack_public_path__ + "img/icon-checkt.190b666f.svg";